import { createGlobalStyle } from 'styled-components';

import { COLOR_BLACK } from 'client/components/MarketingPagesShared/styles';
import { PODCAST_COLORS } from 'client/utils';

export const IntegrationConnectionScreenStyles = createGlobalStyle`
  html,
  body {
    background: ${COLOR_BLACK};
  }
  main > .pageContainer {
    background: ${PODCAST_COLORS.WHITE.color};
  }
`;
